"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainRedirectComponent = exports.LastProjectStorage = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const lodash_1 = __importDefault(require("lodash"));
exports.LastProjectStorage = (function (store) {
    const api = store.namespace("df.recent.project");
    const KEY_PROJECT = "project";
    const isValidString = (value) => lodash_1.default.isString(value) && !lodash_1.default.isEmpty(value);
    const getProject = () => {
        const value = api.get(KEY_PROJECT);
        if (isValidString(value)) {
            return value;
        }
        return undefined;
    };
    const setProject = (value) => {
        if (isValidString(value)) {
            api.set(KEY_PROJECT, value);
        }
    };
    const clear = () => api.clear();
    return {
        getProject,
        setProject,
        clear
    };
})(require("store2"));
const MainRedirectComponent = (props) => {
    const matchHome = (0, react_router_dom_1.useRouteMatch)(AppRouting_1.PATH__HOME);
    const matchProject = (0, react_router_dom_1.useRouteMatch)(AppRouting_1.PATH__PROJECT);
    const { projectsState: { loaded, inProgress, data: projectsData } } = (0, ProjectsProvider_1.useProjectsContext)();
    let redirectToUrl = undefined;
    if (!inProgress && loaded) {
        //projects are loaded here...
        // console.log("MainRedirectComponent: projects are loaded...");
        if (matchHome && matchHome.isExact) {
            //is exact home page -> restore latest project and check if it exists -> then redirect into it
            // console.log("MainRedirectComponent: is exact home page...");
            const storeLastProject = exports.LastProjectStorage.getProject();
            if (!lodash_1.default.isEmpty(storeLastProject)) {
                // console.log("MainRedirectComponent: there is storeLastProject:", storeLastProject);
                const projectsNotEmpty = !lodash_1.default.isEmpty(projectsData);
                if (projectsNotEmpty) {
                    // console.log("MainRedirectComponent: there are projects...");
                    const foundElement = lodash_1.default.find(projectsData, function ({ view: projectProfileView }) {
                        return lodash_1.default.isEqual(projectProfileView.projectApiKey, storeLastProject);
                    });
                    if (lodash_1.default.isNil(foundElement)) {
                        // console.log("MainRedirectComponent: stored project not found - choose first one");
                        redirectToUrl = AppRouting_1.AppPathGenerator.Project.home(lodash_1.default.first(projectsData).view.projectApiKey);
                    }
                    else {
                        // console.log("MainRedirectComponent: stored project found...");
                        redirectToUrl = AppRouting_1.AppPathGenerator.Project.home(storeLastProject);
                    }
                }
                else {
                    //no projects - clear storage
                    // console.log("MainRedirectComponent: no projects - clear storage");
                    exports.LastProjectStorage.clear();
                }
            }
            else {
                // console.log("MainRedirectComponent: no storeLastProject...");
                const projectsNotEmpty = !lodash_1.default.isEmpty(projectsData);
                if (projectsNotEmpty) {
                    // console.log("MainRedirectComponent: no storeLastProject -> choose first one");
                    redirectToUrl = AppRouting_1.AppPathGenerator.Project.home(lodash_1.default.first(projectsData).view.projectApiKey);
                }
            }
        }
        else if (matchProject) {
            // console.log("MainRedirectComponent: is project page...");
            const foundElement = lodash_1.default.find(projectsData, function ({ view: projectProfileView }) {
                return lodash_1.default.isEqual(projectProfileView.projectApiKey, matchProject.params.projectApiKey);
            });
            if (lodash_1.default.isNil(foundElement)) {
                // console.log("MainRedirectComponent: project not found... clear storage and redirect to Home");
                exports.LastProjectStorage.clear();
                return React.createElement(react_router_dom_1.Redirect, { to: AppRouting_1.PATH__HOME });
            }
            // console.log("MainRedirectComponent: set storeLastProject to", foundElement.projectApiKey);
            exports.LastProjectStorage.setProject(foundElement.view.projectApiKey);
        }
        if (redirectToUrl) {
            // console.log("MainRedirectComponent: render redirect");
            return React.createElement(react_router_dom_1.Redirect, { to: redirectToUrl });
        }
        // console.log("MainRedirectComponent: render normal");
        return React.createElement(React.Fragment, null, props.children);
    }
    return React.createElement(React.Fragment, null, props.children);
};
exports.MainRedirectComponent = MainRedirectComponent;
